import { render, staticRenderFns } from "./CustomilyProductsList.vue?vue&type=template&id=15e79a9e&scoped=true"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./CustomilyProductsList.vue?vue&type=style&index=0&id=15e79a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e79a9e",
  null
  
)

export default component.exports